import React, { LegacyRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircleQuestion } from "@fortawesome/pro-solid-svg-icons";
import { faCircleQuestion as faRegularCircleQuestion } from "@fortawesome/pro-regular-svg-icons";
import Tooltip from "../tooltip/Tooltip";
import "./Input.scss";

interface IProps {
    error?: boolean | undefined;
    success?: boolean | undefined;
    filedtitle?: React.ReactNode | undefined;
    help?: React.ReactNode | undefined;
    postchildren?: React.ReactNode | undefined;
    prechildren?: React.ReactNode | undefined;
    insideprechildren?: React.ReactNode | undefined;
    insidepostchildren?: React.ReactNode | undefined;
}

const Input = React.forwardRef(
    (
        props: IProps & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
        ref: LegacyRef<HTMLInputElement>,
    ) => {
        const insertTitleOrHelp = props.filedtitle || props.help;
        const insertPreChildren = props.prechildren || insertTitleOrHelp;

        return (
            <div className="input-field-main-wrapper">
                {insertPreChildren && (
                    <div
                        className={`input-field-header ${props.error ? "input-field-error" : ""}${props.success ? "input-field-success" : ""}`}
                    >
                        {insertTitleOrHelp && (
                            <div className={`input-field-title-container`}>
                                {props.filedtitle && <p>{props.filedtitle}</p>}
                                {props.help && (
                                    <Tooltip title={props.help}>
                                        <FontAwesomeIcon icon={faRegularCircleQuestion} />
                                    </Tooltip>
                                )}
                            </div>
                        )}
                        {props.prechildren}
                    </div>
                )}
                <div className="input-field-wrapper">
                    {props.insideprechildren}
                    <input
                        className="userful-input-field"
                        id={` ${props.error ? "input-field-error" : ""}${props.success ? "input-field-success" : ""}`}
                        {...props}
                        ref={ref}
                    />
                    {props.insidepostchildren}
                </div>
                {props.postchildren && (
                    <div
                        className={`input-field-container ${props.error ? "input-field-error" : ""}${props.success ? "input-field-success" : ""}`}
                    >
                        {props.error && <FontAwesomeIcon icon={faCircleQuestion} />}
                        {props.success && <FontAwesomeIcon icon={faCheckCircle} />}
                        {props.postchildren}
                    </div>
                )}
            </div>
        );
    },
);
export default Input;
